document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdp-main_tab-details a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var modalId = this.getAttribute('href').substring(1);
      var modal = document.querySelector('.ingredients-modal[data-modal="' + modalId + '"]');
      if (modal) {
        e.preventDefault();
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('.modal-close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = this.closest('.ingredients-modal');
      modal.classList.remove('active');
      document.body.style.overflow = '';
    });
  });

  document.querySelectorAll('.modal-overlay').forEach(function (overlay) {
    overlay.addEventListener('click', function () {
      var modal = this.closest('.ingredients-modal');
      modal.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
});
